import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import "./../style/common.css";

const ThankYou = () => {
  const navigate = useNavigate();

  return (
    <div className="thankyou-wrapper">
      <div className="thankyou-card">
        <img src="/Images/thank-you.svg" alt="Thank You" loading="lazy"/>
        <h1>Thank You for Your Order!</h1>
        <p>Your payment was successful. We’re preparing your delicious food.</p>
        <p className="order-text">You’ll be notified once it’s out for delivery or ready for pickup.</p>
        <Button type="primary" size="large" onClick={() => navigate("/")}   className="orange-pay-btn">
          Back to Home
        </Button>
      </div>
    </div>
  );
};

export default ThankYou;
